/**
 * @generated SignedSource<<dabc4a611e40300c0aebc11149d7dcac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedHeroCarousel_viewer$data = {
  readonly vimeoItemsVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_viewer">;
  readonly " $fragmentType": "PdpRespSharedHeroCarousel_viewer";
};
export type PdpRespSharedHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespSharedHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedHeroCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_viewer"
    },
    {
      "alias": "vimeoItemsVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoItemsVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6d300b6f97dd14121f523780982b8322";

export default node;
